const middlewares = {
	layout: {
		button: {
			"with-subscription": "Change Subscription",
			"without-subscription": "Change Subscription",
		},
	},
	"multiple-companies": {
		title: "Locations",
		heading: "You need a premium subscription for this feature",
		description:
			"To use multiple locations you need a <1>Premium</1> subscription.",
	},
	network: {
		title: "Student Pool",
		heading: "You need a premium subscription for this feature",
		description:
			"To use the professional pool you need a <1>Premium</1> subscription.",
	},
	"no-subscription": {
		title: "Unfortunately, you don't have a subscription yet!",
		description:
			"To use {{tenant.name}}, you need an active subscription. You can create one in just a few steps.",
		button: "Choose Subscription",
	},
};

export default middlewares;
